// Acervo fotográfico autorizado. Cópias WebP, sem metadados EXIF.
// Os originais não fazem parte do pacote web.
export const GALLERY_PHOTOS = [
  {
    "id": "lab-debian",
    "src": "/img/registro/lab-debian.webp",
    "thumb": "/img/registro/lab-debian-thumb.webp",
    "group": "Laboratório",
    "title": "Laboratório Linux em funcionamento",
    "caption": "Estações do laboratório com Debian em execução após a preparação do ambiente.",
    "alt": "Visão ampla das estações do laboratório com ambiente Linux Debian"
  },
  {
    "id": "lab-implantado",
    "src": "/img/registro/lab-implantado.webp",
    "thumb": "/img/registro/lab-implantado-thumb.webp",
    "group": "Laboratório",
    "title": "Estações preparadas para uso",
    "caption": "Registro do ambiente montado com estações e equipamentos reaproveitados.",
    "alt": "Linhas de estações de trabalho montadas em sala de treinamento"
  },
  {
    "id": "lote-b13",
    "src": "/img/registro/lote-b13.webp",
    "thumb": "/img/registro/lote-b13-thumb.webp",
    "group": "Hardware",
    "title": "Lote de dispositivos B13",
    "caption": "Dispositivos preparados para avaliação de compatibilidade e reaproveitamento.",
    "alt": "Caixas de dispositivos TV Box B13 organizadas em um lote"
  },
  {
    "id": "placa-arm",
    "src": "/img/registro/placa-arm.webp",
    "thumb": "/img/registro/placa-arm-thumb.webp",
    "group": "Hardware",
    "title": "Inspeção de placa ARM",
    "caption": "Placa de dispositivo embarcado exposta para identificação dos componentes e análise de compatibilidade.",
    "alt": "Placa eletrônica azul de TV Box com dissipador e portas de conexão"
  },
  {
    "id": "hardware-aberto",
    "src": "/img/registro/hardware-aberto.webp",
    "thumb": "/img/registro/hardware-aberto-thumb.webp",
    "group": "Hardware",
    "title": "Dispositivo aberto para testes",
    "caption": "Inspeção visual de componentes e interfaces de hardware embarcado.",
    "alt": "TV Box aberta mostrando placa eletrônica verde e conexões"
  },
  {
    "id": "componentes-arm",
    "src": "/img/registro/componentes-arm.webp",
    "thumb": "/img/registro/componentes-arm-thumb.webp",
    "group": "Hardware",
    "title": "Detalhe dos componentes",
    "caption": "Detalhes de memória, controladores e trilhas usados na identificação das revisões de placa.",
    "alt": "Detalhe ampliado de componentes eletrônicos de uma TV Box"
  },
  {
    "id": "tvbox-preparacao",
    "src": "/img/registro/tvbox-preparacao.webp",
    "thumb": "/img/registro/tvbox-preparacao-thumb.webp",
    "group": "Hardware",
    "title": "Unidade de TV Box para preparação",
    "caption": "Exemplo de equipamento recebido para testes e preparação.",
    "alt": "Dispositivo TV Box preto em teste numa bancada de trabalho"
  },
  {
    "id": "desktop-linux",
    "src": "/img/registro/desktop-linux.webp",
    "thumb": "/img/registro/desktop-linux-thumb.webp",
    "group": "Linux",
    "title": "Linux inicializado",
    "caption": "Ambiente desktop Linux em funcionamento após testes de inicialização.",
    "alt": "Monitor exibindo uma sessão desktop Linux com interface gráfica"
  },
  {
    "id": "scripts-tvbox",
    "src": "/img/registro/scripts-tvbox.webp",
    "thumb": "/img/registro/scripts-tvbox-thumb.webp",
    "group": "Linux",
    "title": "Testes de rede e scripts Linux",
    "caption": "Diagnóstico de interface de rede em dispositivo embarcado e verificação de scripts locais.",
    "alt": "Terminal Linux mostrando scripts e mensagem de ausência de interface Wi-Fi"
  },
  {
    "id": "ffmpeg-stream",
    "src": "/img/registro/ffmpeg-stream.webp",
    "thumb": "/img/registro/ffmpeg-stream-thumb.webp",
    "group": "Automação",
    "title": "Processamento de vídeo com FFmpeg",
    "caption": "Teste técnico de codificação e transmissão local de vídeo pelo FFmpeg em PowerShell.",
    "alt": "Terminal PowerShell apresentando logs de codificação de vídeo com FFmpeg"
  }
];
export const PHOTO_GROUPS = ["Tudo", "Laboratório", "Hardware", "Linux", "Automação"];
